import { ILaborMetric } from 'utils/jitMetricUtils';
import { IActivityReportRowInfo } from '../hooks/ActivityReportData';

const metricToRowInfo = (metricTotal: ILaborMetric) => {
  return {
    regularHours: metricTotal.regularSeconds + metricTotal.paidTimeOffSeconds,
    regularHoursDec: metricTotal.regularSeconds + metricTotal.paidTimeOffSeconds,
    overtimeHours: metricTotal.overtimeSeconds,
    overtimeHoursDec: metricTotal.overtimeSeconds,
    doubleTimeHours: metricTotal.doubleTimeSeconds,
    doubleTimeHoursDec: metricTotal.doubleTimeSeconds,
    totalHours: metricTotal.totalSeconds,
    totalHoursDec: metricTotal.totalSeconds,
    regularCost: metricTotal.regularCost + metricTotal.timeOffCost,
    overtimeCost: metricTotal.overtimeCost,
    doubletimeCost: metricTotal.doubleTimeCost,
    laborBurden: metricTotal.laborBurden,
    totalCost: metricTotal.totalCost,
  };
};

const rowInfoToMetric = (rowInfo: IActivityReportRowInfo): ILaborMetric => {
  return {
    regularSeconds: rowInfo.regularHours,
    overtimeSeconds: rowInfo.overtimeHours,
    doubleTimeSeconds: rowInfo.doubleTimeHours,
    totalSeconds: rowInfo.totalHours,
    regularCost: rowInfo.regularCost,
    overtimeCost: rowInfo.overtimeCost,
    doubleTimeCost: rowInfo.doubletimeCost,
    laborBurden: rowInfo.laborBurden,
    totalCost: rowInfo.totalCost,
    paidTimeOffSeconds: 0,
    timeOffSeconds: 0,
    timeOffCost: 0,
    equipmentCost: 0,
  };
};

export const activityReportUtils = {
  metricToRowInfo,
  rowInfoToMetric,
};
